export const formatDataId = (val: string): string => {
    return val.replace(/\s+/g, '-').toLowerCase()
}

export const formatUrl = (val: string): string => {
    return val.substr(1).replace(/\//g, '-')
}